import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { DataService } from '../../../services/forms/referenc-center/data.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/map-reference-invoice.component.html',
})
export class MapReferanceInvoiceListComponent implements OnInit {
  @Input()
  SI_NO: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;
  mapReferanceInvoiceList: any[] = [];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "MapReferanceInvoiceListGrid"
  searchFields: any[] = ['SI_ID', 'INVOICE_DATE', 'CUSTOMER_NAME'];
  public searchString;
  constructor(private apiService: DataService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.invoiceID, field: 'SI_ID', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.invoiceDate, field: 'INVOICE_DATE', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.customerName, field: 'CUSTOMER_NAME', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.apiService.getReferenceInvoice()
      .subscribe(arg => { console.log(arg); this.mapReferanceInvoiceList = arg.body });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
